<template>
	<section v-if="isLoadingOk" class="small text-hide-overflow">

		<!-- 1-3 Reservations -->
		<div v-for="reservation in reservations" :key="reservation.id" class="bg-white b-rounded p-x-grid p-y-1 m-b-xs flex-card">
			<span>
				<p class="m-b-0"><a :href="reservation.url" class="font-weight-bold" :data-testid="`reservationName_${reservation.id}`">{{ reservation.eventName }}</a><span v-if="!isSingleMembership" :data-testid="`memberName_${reservation.id}`"> for {{ reservation.memberName }}</span></p>
				<TemporalDisplay :start="reservation.startMoment" template="dateShort"/> from <TemporalDisplay :start="reservation.startMoment" :end="reservation.endMoment" template="time"/>
				<p class="m-b-0" :data-testid="`locationValue_${reservation.id}`">{{ reservation.location }}</p>
			</span>
			<span class="flex-card-cta">
				<button class="btn btn-link btn-link-simple btn-sm" @click="addToCalendar(reservation)" :data-testid="`addToCalendar_${reservation.id}`">Add to Calendar</button>
			</span>
		</div>

		<p v-if="userKnown && reservations.length" class="m-x-grid m-y-sm"><a class="hp-view-reservations" :href="reservationsNav">Manage Reservations</a></p>

		<!-- No Reservations -->
		<div v-else-if="userKnown && !reservations.length" class="bg-white b-rounded p-x-grid p-y-1 m-b-xs">
			No upcoming reservations
		</div>

		<!-- Not Logged In -->
		<div v-else-if="!userKnown" class="bg-white b-rounded p-x-grid p-y-1 m-b-xs">
			<a :href="loginNav">Log in to view reservations</a>
		</div>

		<AddToCalendar ref="addToCalendarComponent" />

	</section>
</template>

<script lang="ts">
import moment from 'moment';
import TemporalDisplay from '@/components/schreg-common/TemporalDisplay.vue';
import AddToCalendar from '@/components/schreg-common/AddToCalendar.vue';
import { baseComponentMixin } from '@/mixins/baseComponent.mixin';
import { FrameworkService } from '@/services/framework.service';
import { StateService } from '@/services/state.service';
import { UxSchedulesApi, Reservation } from '@/apis/uxSchedules.api';
import { defineComponent } from 'vue';

export default defineComponent({
	name: 'MyReservationsBriefComponent',
	config: {
		key: 'schreg.myReservationsBrief',
		devPath: 'my-reservations-brief',
		exported: true
	},
	components: {
		TemporalDisplay,
		AddToCalendar
	},
	mixins: [baseComponentMixin],
	data() {
		return {
			reservations: [] as Reservation[],
			isSingleMembership: false,
			loginNav: '',
			reservationsNav: ''
		};
	},
	mounted() {
		this.getFrameworkData(this.completeMounting, ['ClubStore', 'ProfileStore', 'UrlStore']);
	},
	methods: {
		completeMounting() {
			const members = StateService.getAllMemberIdArray();
			this.isSingleMembership = members && members.length === 1;

			if (members && members.length > 0 && this.userKnown) {
				UxSchedulesApi
					.getMyReservationsBrief(3)
					.then(response => {
						if (!response.ok) {
							return this.mountServerError(true, response.data.error);
						}

						if (response.data.results.length) {
							this.reservations = response.data.results;
							this.reservations.forEach(function(result) {
								result.startMoment = moment.parseZone(result.start);
								result.endMoment = moment.parseZone(result.end);
								result.url = FrameworkService.eventUrl(result.eventId);
							});
						}
						this.reservationsNav = FrameworkService.globalUrl('myReservations');
						this.isLoadingOk = true;
					});
			} else {
				this.loginNav = FrameworkService.globalUrl('loginResource');
				this.isLoadingOk = true;
			}
		},
		addToCalendar(reservation: Reservation) {
			(this.$refs.addToCalendarComponent as InstanceType<typeof AddToCalendar>).open(
				reservation.eventId, // eventId
				reservation.id, // registrationId
				reservation.reservationType === 'Spa', // isSpaReservation
				reservation.start // reservationDate
			);
		}
	}
});
</script>

<style lang="scss">
@import "@/common/styles/flex-card.scss";
</style>
